import Api from '@/api'

export default {
    state: {
        sessionId: '',
        msg: '',
        pageType: "",
        userName: "",
        userType: "",
        retCode: 1
    },
    mutations: {
        save_session(state, payload) {
            state.sessionId = payload.session_id,
                state.pageType = payload.save_pageType,
                state.userName = payload.save_userName,
                state.userType = payload.save_userType,
                state.retCode = payload._retcode
        },
        send_msg(state, payload) {
            state.msg = payload._msg
        },
        send_msg2(state, payload) {
            state.msg = payload._msg,
                state.retCode = payload._retcode
        },
    },
    actions: {
        login({commit}, payload) {
            return Api.login(payload)
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/components/login_store.js